module.exports = __webpack_public_path__ + "static/media/Step-6-B2B---V_5.47035c46.png";